import FontUploadIcon from "../../../images/cloud--upload.svg";
import "./customLinkBlock.scss";
export const customTraits = (editor, setOpenDocumentModal) => {
  editor.Traits.addType("href", {
    // Expects as return a simple HTML string or an HTML element

    onEvent({ elInput, component, event }) {
      let attribute = component.getAttributes();

      component.set("attributes", {
        href: event.target.value,
        Title: attribute.Title,
        target: attribute.target || "_self",
      });
    },
    onkeyup({ elInput, component, event }) {},
    createInput({ trait }) {
      // Here we can decide to use properties from the trait

      // Create a new element container and add some content
      const el = document.createElement("div");
      el.innerHTML = `
            <div class="href-inputs customTraits fontUploadStyle" style="padding-left:0" >
              <input class="hrefInput"  type="url" title="" placeholder="eg. https://google.com" />
              <CustomTooltip
              title="Upload PDF"
              style= "padding-top: 9px;"
              classes="  editor-wrapper-preview-popover"
            >
              <img
                alt="InfoIconWhite"
                src=${FontUploadIcon}
                style={{ width: "24px", height: "24px" }}
                className="infoIconL"
                id="buttonclick"
              />
            </CustomTooltip>
             
            </div>
          `;
      // <button id="buttonclick">click ME</button>
      // Let's make our content interactive
      const inputsUrl = el.querySelector("#buttonclick");
      //   const inputsEmail = el.querySelector(".href-next__email-inputs");
      //   const inputType = el.querySelector(".href-next__type");
      inputsUrl.addEventListener("click", (ev) => {
        setOpenDocumentModal(true);
        // setLoading("Datta");
        //  ;
      });

      return el;
    },
    onUpdate({ elInput, component }) {
      elInput.querySelector(".hrefInput").value =
        component.getAttributes().href || "";
      if (component.getAttributes()?.href?.split("/")?.pop()?.includes("pdf"))
        elInput.querySelector(".hrefInput").title = component
          .getAttributes()
          .href.split("/")
          .pop();
    },
  });
};
